
import React, { Fragment, useEffect } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { AiOutlineMinus, AiOutlinePlus } from 'react-icons/ai'
import { Link } from 'react-router-dom'
import { unsetCart } from '../store/cartOpenSlice'
import { useSelector, useDispatch } from 'react-redux'

const Cart = () => {

    const cartOpen = useSelector((state) => state.cartOpen.value)
    const dispatch = useDispatch()
    const [products, setProducts] = React.useState([])
    const [total, setTotal] = React.useState(0)
    // const [quantity, setQuantity] = React.useState(0);

    const calaculateTotal = (data) => {
        let total = 0;
        data.forEach((item) => {
            total += item.price
        })
        setTotal(total)
    }


    const removeProduct = (id) => {
        console.log("remove product");
        try {
            fetch(process.env.REACT_APP_SERVER_URL + '/cart/deleteAllItem', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({
                    productId: id
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.success) {
                        setProducts(data.cart)
                        calaculateTotal(data.cart)
                    }
                }
                )
        } catch (error) {
            console.log(error)
        }
    }

    const increaseQuantity = (id) => {
        try {
            fetch(process.env.REACT_APP_SERVER_URL + '/cart/addtocart', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({
                    productId: id
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.success) {
                        setProducts(data.cart)
                        calaculateTotal(data.cart)
                    }
                }
                )
        } catch (error) {
            console.log(error)
        }
    }

    const decreaseQuantity = (id) => {
        console.log(products);
        if (products.quantity === 1) {
            console.log("quantity = 1");
            removeProduct(id);
            return;
        }
        try {
            fetch(process.env.REACT_APP_SERVER_URL + '/cart/deleteItem', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({
                    productId: id
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.success) {
                        setProducts(data.cart)
                        calaculateTotal(data.cart)
                    }
                }
                )
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        try {
            if (localStorage.getItem('token'))
                fetch(process.env.REACT_APP_SERVER_URL + '/cart/getcart', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    },

                })
                    .then(res => res.json())
                    .then(data => {
                        if (data.success) {
                            setProducts(data.cart)
                            calaculateTotal(data.cart)
                        }
                    })
        } catch (error) {
            console.log(error)
        }
    }, [cartOpen])





    return (
        <Transition.Root show={cartOpen} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={() => dispatch(unsetCart())}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-in-out duration-500"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-500"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity " />
                </Transition.Child>

                <div className="fixed inset-0 overflow-hidden">
                    <div className="absolute inset-0 overflow-hidden">
                        <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                            <Transition.Child
                                as={Fragment}
                                enter="transform transition ease-in-out duration-500 sm:duration-700"
                                enterFrom="translate-x-full"
                                enterTo="translate-x-0"
                                leave="transform transition ease-in-out duration-500 sm:duration-700"
                                leaveFrom="translate-x-0"
                                leaveTo="translate-x-full"
                            >
                                <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                                    <div className="flex h-full flex-col overflow-y-scroll bg-white dark:bg-black dark:text-white shadow-xl">
                                        <div className="flex-1 overflow-y-auto py-6 px-4 sm:px-6">
                                            <div className="flex items-start justify-between">
                                                <Dialog.Title className="text-lg font-medium text-gray-900 dark:text-white ">Shopping cart</Dialog.Title>
                                                <div className="ml-3 flex h-7 items-center">
                                                    <button
                                                        type="button"
                                                        className="-m-2 p-2 text-gray-400 dark:text-white  hover:text-gray-500"
                                                        onClick={() => dispatch(unsetCart())}
                                                    >
                                                        <span className="sr-only">Close panel</span>
                                                        <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="mt-8">
                                                <div className="flow-root">
                                                    <ul className="-my-6 divide-y divide-gray-200">
                                                        {products.map((product) => (
                                                            <li key={product._id} className="flex py-6">
                                                                <div className="h-24 w-24 flex-shrink-0 overflow-hidden rounded-md border border-gray-200">
                                                                    <img
                                                                        src={product.imgUrl}
                                                                        alt='...'
                                                                        className="h-full w-full object-cover object-center"
                                                                    />
                                                                </div>

                                                                <div className="ml-4 flex flex-1 flex-col">
                                                                    <div>
                                                                        <div className="flex justify-between dark:text-white  text-base font-medium text-gray-900">
                                                                            <h3 className='truncate w-40'>
                                                                                <a target="_blank" href={`/dp/${product.products}`} rel="noreferrer">{product.name}</a>
                                                                            </h3>
                                                                            <p className="ml-4">₹ {product.price}</p>
                                                                        </div>
                                                                        <p className="mt-1 text-sm text-gray-500">{product.type}</p>
                                                                    </div>
                                                                    <div className="flex flex-1 items-end justify-between text-sm">
                                                                        <p className="text-gray-500 dark:text-white  flex justify-center items-center gap-1">Qty <AiOutlineMinus
                                                                            onClick={() => decreaseQuantity(product.products)} className='cursor-pointer'

                                                                        /> {product.quantity} <AiOutlinePlus className='cursor-pointer'
                                                                            onClick={() => increaseQuantity(product.products)}
                                                                            /></p>

                                                                        <div className="flex">
                                                                            <button
                                                                                type="button"
                                                                                className="font-medium text-green-600 hover:text-green-500"
                                                                                onClick={() => {
                                                                                    removeProduct(product.products)
                                                                                }}
                                                                            >
                                                                                Remove
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="border-t border-gray-200 py-6 px-4 sm:px-6">
                                            <div className="flex justify-between text-base font-medium text-gray-900 dark:text-white ">
                                                <p>Subtotal</p>
                                                <p>Rs {total}</p>
                                            </div>
                                            <p className="mt-0.5 text-sm text-gray-500">Shipping and taxes calculated at checkout.</p>
                                            <div className="mt-6">
                                                {total > 0 ?
                                                    <Link
                                                        to="/checkout"
                                                        onClick={() => dispatch(unsetCart())}
                                                        className="flex items-center justify-center rounded-md border border-transparent bg-green-600 px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-green-700"
                                                    >
                                                        Checkout
                                                    </Link> :
                                                    <></>
                                                }
                                            </div>
                                            <div className="mt-6 flex justify-center text-center text-sm text-gray-500">
                                                <p>
                                                    or
                                                    <button
                                                        type="button"
                                                        className="font-medium text-green-600 hover:text-green-500"
                                                        onClick={() => dispatch(unsetCart())}
                                                    >
                                                        &nbsp; Continue Shopping
                                                        <span aria-hidden="true"> &rarr;</span>
                                                    </button>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </div>
            </Dialog>
        </Transition.Root >
    )
}

export default Cart